// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"v8-z"};